/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper';

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './territory-experience-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const territoryExperienceSlider = () => {
    let args = {
        slidesPerView: 3.35,
        spaceBetween: 40,
        breakpoints: {
            0: {
                slidesPerView: 1.1,
            },
            500: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3.35,
            }
        },
    };
    let territoryExpSwiper = new Swiper(document.querySelector('.territoryExpSwiper'), args);
}

export default territoryExperienceSlider;

//--------------------------------------------------------------------//